import { RequestKeys, ResourcesKeys } from "../../../enums";
import { firestore } from "../../firebase";
import { getFinalList } from "../../../utils/funcs";

const userGuideResource = {
  [ResourcesKeys.UserGuide]: {
    [RequestKeys.GET_LIST]: async (queryData) =>
      getFinalList(firestore.collection(ResourcesKeys.UserGuide), {
        ...queryData,
        limit: queryData.pagination.perPage,
        filters: queryData.filter,
      }),
  },
};

export default userGuideResource;
